<form>
	<ui-modal [modalTitle]="id === 'new' ? 'Add Project' : 'Project Details'" scrollable="true">
		<ng-container *ngIf="data">
			<ui-form labelWidth="10rem">
				<ui-form-control label="Customer">
					<div class="d-flex">
						<input class="form-control" [(ngModel)]="data.customer_name" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off" readonly>
						<ng-container *ngIf="!customerId && !data.locked">
							<button type="button" class="btn btn-outline-secondary p-2 ml-1" (click)="selectCustomerModal.open()"><i class="wq wq-search"></i></button>
							<div *ngIf="!app.orgInfo?.disallow_contact_edit" class="dropdown dropdown-light d-inline-block ml-1">
								<button type="button" class="btn btn-outline-success p-2 dropdown-toggle" data-toggle="dropdown"><i class="wq wq-add"></i></button>
								<div class="dropdown-menu">
									<button type="button" class="dropdown-item dropdown-item-success" (click)="addCustomer()">Add Customer</button>
									<a [href]="'/' + app.org + '/customer'" target="_blank" class="dropdown-item dropdown-item-success">Go to Customers<i class="wq wq-open-new ml-2"></i></a>
								</div>
							</div>
						</ng-container>
					</div>
				</ui-form-control>

				<ui-form-control label="Description">
					<input class="form-control" [(ngModel)]="data.project.description" (input)="descriptionChanged()" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off" appAutoFocus>
				</ui-form-control>
				<ui-form-control *ngIf="id !== 'new'" label="Project #">
					<input class="form-control text-right w-30" [(ngModel)]="data.project.project_no" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
				</ui-form-control>
				<ui-form-control *ngIf="app.orgInfo?.allow_customer_portal" label="Customer Portal">
					<label class="custom-control custom-control-success custom-switch mb-0 mt-2">
						<input type="checkbox" class="custom-control-input" [(ngModel)]="portalAccess" [ngModelOptions]="{ standalone: true }">
						<span class="custom-control-label">{{portalAccess ? 'Enabled' : 'Disabled'}}</span>
					</label>
				</ui-form-control>
				<hr>
				<ui-form-control label="Assignee">
					<select class="custom-select" [(ngModel)]="data.project.user_id" [ngModelOptions]="{ standalone:true }">
						<option [ngValue]="null"></option>
						<option *ngFor="let u of userList" [ngValue]="u.id">{{u.name}}</option>
					</select>
				</ui-form-control>
				<ui-form-control *ngIf="data.warehouse_list.length" label="Warehouse">
					<select class="custom-select" [(ngModel)]="data.project.warehouse_id" [ngModelOptions]="{ standalone:true }">
						<option [ngValue]="null">Default</option>
						<option *ngFor="let w of data.warehouse_list" [ngValue]="w.id">{{w.name}}</option>
					</select>
				</ui-form-control>
				<ui-form-control *ngIf="id === 'new' && data.currencies.length > 1" label="Currency">
					<select class="custom-select w-auto" [(ngModel)]="data.project.currency_id" [ngModelOptions]="{ standalone: true }" [disabled]="currencyId">
						<option *ngFor="let c of data.currencies" [ngValue]="c.currency_id">{{c.currency_id}}</option>
					</select>
				</ui-form-control>

				<ui-form-control label="Label" *ngIf="data?.label_list && data.label_list.length">
					<div #multiselectdropdown class="multi-select">
						<div class="selected-labels custom-select" (click)="toggleDropdown()">
							<span class="selectable mr-3" *ngFor="let labelData of selectedLabels">
								<ui-label class="selectable" [label_text]="labelData.text" [label_color]="labelData.label_color" (click)="toggleSelection(labelData);$event.stopPropagation();"></ui-label>
							</span>
						</div>
						<div class="dropdown">
							<div class="dropdown-menu shadow-sm bg-white border-lightgrey" [ngClass]="{ 'show': isDropdownOpen }">
								<ng-container *ngFor="let labelData of labelList">
									<div class="selectable hoverable rounded p-1" (click)="toggleSelection(labelData);$event.stopPropagation();">
										<ui-label [label_text]="labelData.text" [label_color]="labelData.label_color"></ui-label>
									</div>
								</ng-container>
								<div *ngIf="!labelList.length" class="text-secondary p-1">No more labels.</div>
							</div>
						</div>
					</div>
				</ui-form-control>
				<hr>
				<div class="d-flex mb-3">
					<h3 class="flex-weight-1">Project Location</h3>
					<div *ngIf="addresses?.length && hasAddress">
						<button type="button" class="btn"
							[ngClass]="hasMatchingAddress ? 'btn-success' : 'btn-outline-success'" (click)="openAddressPicker()">
							{{data.project.address_name ? data.project.address_name : 'Use Existing Address'}}
						</button>
					</div>
				</div>
				<ui-form-control label="Address">
					<input class="form-control" [(ngModel)]="data.project.address_line_1" (ngModelChange)="checkAddressMatch(500)" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
				</ui-form-control>
				<ui-form-control>
					<input class="form-control" [(ngModel)]="data.project.address_line_2" (ngModelChange)="checkAddressMatch(500)" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
				</ui-form-control>
				<ui-form-control>
					<input class="form-control" [(ngModel)]="data.project.address_line_3" (ngModelChange)="checkAddressMatch(500)" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
				</ui-form-control>
				<ui-form-control label="Town / City">
					<input class="form-control" [(ngModel)]="data.project.posttown" (ngModelChange)="checkAddressMatch(500)" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
				</ui-form-control>
				<ui-form-control label="County / State">
					<input class="form-control" [(ngModel)]="data.project.county" (ngModelChange)="checkAddressMatch(500)" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
				</ui-form-control>
				<ui-form-control label="Postcode / ZIP">
					<input class="form-control w-50" [(ngModel)]="data.project.postcode" (ngModelChange)="checkAddressMatch(500)" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
				</ui-form-control>
				<ui-form-control label="Country">
					<input class="form-control" [(ngModel)]="data.project.country" (ngModelChange)="checkAddressMatch(500)" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
				</ui-form-control>

				<ng-container *ngIf="id === 'new' && app.orgInfo?.allow_procurement && app.hasAddress(data.project)">
					<ui-form-control label="">
						<label class="custom-control custom-checkbox mt-2 d-inline-block">
							<input type="checkbox" [disabled]="siteDisabled" class="custom-control-input" [ngModelOptions]="{ standalone: true }" [(ngModel)]="autoCreateProjectSite">
							<span class="custom-control-label">Automatically create a Site location</span>
						</label>
						<div class="text-danger text-bold" *ngIf="siteDisabled">You have already selected a Site Location</div>

						<div class="text-danger text-bold" *ngIf="!siteDisabled && addressMatch && addressMatch.project_count">
							There {{addressMatch?.project_site_count > 1 ? 'are' : 'is'}} already {{addressMatch?.project_site_count}} Site Location{{addressMatch?.project_site_count > 1 ? 's' : ''}} across {{addressMatch?.project_count}} Project{{addressMatch?.project_count > 1 ? 's' : ''}} for this Address
						</div>
					</ui-form-control>
					<ui-form-control *ngIf="autoCreateProjectSite" label="Site Location Name">
						<input class="form-control" [(ngModel)]="siteName" (input)="siteNameChanged()" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
						<div class="text-info mt-2"><i class="wq wq-info mr-1"></i>This location will be attached to this project for inventory delivery.</div>
					</ui-form-control>
				</ng-container>

				<ng-container *ngIf="app.orgInfo?.allow_work_hub">
					<hr>
					<ui-form-control label="Calendar Colour">
						<div class="input-group">
							<div class="input-group-prepend">
								<p-colorPicker [(ngModel)]="data.project.schedule_color" [ngModelOptions]="{ standalone: true }"></p-colorPicker>
							</div>
							<input type="text" class="form-control" [(ngModel)]="data.project.schedule_color" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
						</div>
					</ui-form-control>
					<ui-form-control label="Include Travel">
						<label class="custom-control custom-checkbox mt-2 d-inline-block">
							<input type="checkbox" class="custom-control-input" [ngModelOptions]="{ standalone: true }" [(ngModel)]="includeTravelCost">
							<span class="custom-control-label">Include Travel on Cost</span>
						</label>
						<div class="text-info"><i class="wq wq-info mr-1"></i>This will factor in all travel hours when calculating the project's cost in the overview.</div>
					</ui-form-control>
				</ng-container>

				<hr>
				<ui-form-control label="Invoicing">
					<label class="custom-control custom-checkbox mt-2 d-inline-block">
						<input type="checkbox" class="custom-control-input" [ngModelOptions]="{ standalone: true }" [(ngModel)]="overrideInvoiceDetails">
						<span class="custom-control-label">Override customer invoicing details</span>
					</label>
					<div class="text-info"><i class="wq wq-info mr-1"></i>New invoices raised for this project will bill to these details instead of the customer's.</div>
				</ui-form-control>
				<ng-container *ngIf="overrideInvoiceDetails">
					<div class="d-flex mb-3">
						<h3 class="flex-weight-1">Invoicing Details</h3>
						<div *ngIf="overrideInvoiceDetails && addresses?.length && hasAddress">
							<button type="button" class="btn"
								[ngClass]="hasMatchingInvoiceAddress ? 'btn-success' : 'btn-outline-success'" (click)="openInvoiceAddressPicker()">
								{{invoiceAddressLabel ? invoiceAddressLabel : 'Select Address'}}
							</button>
						</div>
					</div>
					<ui-form-control label="Name">
						<input class="form-control" [(ngModel)]="data.project.invoice_name" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
					</ui-form-control>
					<ui-form-control label="Address line 1">
						<input class="form-control" [(ngModel)]="data.project.invoice_address_line_1" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
					</ui-form-control>
					<ui-form-control label="Address line 2">
						<input class="form-control" [(ngModel)]="data.project.invoice_address_line_2" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
					</ui-form-control>
					<ui-form-control label="Address line 3">
						<input class="form-control" [(ngModel)]="data.project.invoice_address_line_3" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
					</ui-form-control>
					<ui-form-control label="Town / City">
						<input class="form-control" [(ngModel)]="data.project.invoice_posttown" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
					</ui-form-control>
					<ui-form-control label="County / State">
						<input class="form-control" [(ngModel)]="data.project.invoice_county" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
					</ui-form-control>
					<ui-form-control label="Postcode / ZIP">
						<input class="form-control w-50" [(ngModel)]="data.project.invoice_postcode" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
					</ui-form-control>
					<ui-form-control label="Country">
						<input class="form-control" [(ngModel)]="data.project.invoice_country" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
					</ui-form-control>
				</ng-container>

			</ui-form>
		</ng-container>

		<div class="flex-weight-1" ui-modal-footer></div>
		<button type="button" class="btn btn-secondary" (click)="modal.close()" [disabled]="disabled" ui-modal-footer>Cancel</button>
		<button type="button" class="btn btn-primary" (click)="saveButton()" [disabled]="disabled" ui-modal-footer>Save</button>
	</ui-modal>
</form>

<modal-edit-customer (close)="customerEditModalClosed($event)"></modal-edit-customer>
<modal-select-customer (close)="selectCustomerModalClosed($event)"></modal-select-customer>
<app-modal-select-address (close)="addressPickerClosed($event)"></app-modal-select-address>
